import isInApp from './isInApp'
import brandedNames from './brandedNames'
import getIn from '../utils/getIn'

function addUniqueValues (origin, values) {
    return values.reduce((accumulator, key) => {
        if (!~accumulator.indexOf(key)) {
            accumulator.push(key)
        }
        return accumulator
    }, origin)
}

class Translations {
    constructor () {
        this.mapReplacement = {}
        this.skipKeys = ['addToCart', 'config', 'background', 'src', 'alt', 'visual', 'link', 'id', 'dataLabel', 'href', 'href_mobile', 'icon', 'sku', 'videoId', 'url']
        this.skipTags = ['script', 'style', 'iframe', 'canvas']
        this.setReplacements()
        this.getApiDescription = true
    }

    setToSkip ({ keys = [], tags = [] } = {}) {
        this.skipKeys = addUniqueValues(this.skipKeys, keys)
        this.skipTags = addUniqueValues(this.skipTags, tags)
    }

    setReplacements (additionalBrands = []) {
        brandedNames.unshift(...additionalBrands)
        const regexp = []
        brandedNames.forEach((branded) => {
            const brandedSearch = branded.search.toLowerCase()
            const brandedReplace = branded.replace
            this.mapReplacement[brandedSearch] = typeof (brandedReplace) === 'string' ? brandedReplace : brandedReplace()
            regexp.push(brandedSearch.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'))
        })
        this.regexp = new RegExp(`\\b(${regexp.join('|')})\\b`, 'gi')
    }

    mutate (json, isDescendant = false) {
        if (!isDescendant) {
            this.skipValues = this.skipKeys
                .filter(key => ~key.indexOf('.'))
                .map(key => getIn(key, json))
                .filter(value => !!value)
        }
        Object.keys(json).forEach(property => {
            const value = json[property]
            if (~this.skipKeys.indexOf(property) || !value || ~this.skipValues.indexOf(value)) {
                return
            }
            if (typeof (value) === 'object') {
                if (value.length > 0 && typeof (value[0]) !== 'string') {
                    value.forEach(item => this.mutate(item, true))
                } else {
                    this.mutate(value, true)
                }
            } else if (typeof (value) === 'string') {
                if (isInApp && value.indexOf('http') === 0 && value.indexOf(' ') < 0) {
                    json[property] = '#'
                } else {
                    let node = document.createElement('div')
                    node.innerHTML = value
                    node = this.replaceText(node)
                    json[property] = node.innerHTML
                }
            }
        })
    }

    replaceText (node) {
        let child = node.firstChild
        while (child) {
            switch (child.nodeType) {
            case 1:
                if (this.skipTags.indexOf(child.tagName.toLowerCase()) > -1) {
                    break
                }
                if (child.hasAttribute('data-tooltip')) {
                    const spanTooltip = document.createElement('span')
                    spanTooltip.className = 'v_tooltip'
                    spanTooltip.innerHTML = child.getAttribute('data-tooltip')
                    child.appendChild(spanTooltip)
                }
                if (child.tagName === 'A' && isInApp) {
                    child.setAttribute('href', '#')
                }
                this.replaceText(child)
                break
            case 3:
                let bk = 0
                child.data.replace(this.regexp, (...args) => {
                    const matchLength = args[0].length
                    const newTextNode = child.splitText(args[args.length - 2] + bk)
                    bk -= child.data.length + matchLength
                    newTextNode.data = newTextNode.data.substr(matchLength)
                    const match = args[0].toLowerCase()
                    let replacement = this.mapReplacement[match]
                    if (typeof (replacement) === 'string') {
                        const nodeReplacement = document.createElement('div')
                        nodeReplacement.innerHTML = replacement
                        nodeReplacement.querySelector('strong.v_brand').setAttribute('term', match)
                        replacement = nodeReplacement.firstChild
                        this.mapReplacement[match] = replacement
                    }
                    child.parentNode.insertBefore(replacement.cloneNode(true), newTextNode)
                    child = newTextNode
                })
                child.data = child.data.replace(/__/g, '')
                this.regexp.lastIndex = 0
                break
            }
            child = child.nextSibling
        }
        return node
    }
}

export default new Translations()
